import { useNavigate } from "react-router-dom";
import { SUITE_MASTER } from "./toolGradients.js";

// ─── BackArrow — top-of-page back affordance ───────────────────────
//
// Spec (Ian): an ARROW only — no word, no tile/container around it.
// Gradient-stroked:
//   - on a SUITE page  → NerdSuite violet → that suite's color
//   - on a TOOL page   → that suite's color → the tool's color
//
// Pass { from, to } explicitly, or pass { suite } for the suite-page
// default (violet → suite). Tool pages pass the suite color → tool
// color from the gradient the tool already computes.
const VIOLET = SUITE_MASTER.stack; // #7C3AED — NerdSuite family violet

export default function BackArrow({ to = -1, from, toColor, suite, size = 26 }) {
  const nav = useNavigate();
  const a = from || VIOLET;
  const b = toColor || (suite ? SUITE_MASTER[suite] : SUITE_MASTER.stack);
  const gid = `ba-${a}-${b}`.replace(/[^a-z0-9-]/gi, "");
  const s = size;

  return (
    <button
      onClick={() => nav(to)}
      aria-label="Back"
      style={{ background: "none", border: "none", padding: 0, cursor: "pointer", lineHeight: 0, display: "inline-flex" }}
    >
      <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
        <defs>
          <linearGradient id={gid} x1="1" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor={a} />
            <stop offset="1" stopColor={b} />
          </linearGradient>
        </defs>
        <path
          d="M15 5l-7 7 7 7"
          stroke={`url(#${gid})`}
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
